import AethelonLevelFlow from "./AethelonLevelFlow";

const resolvePath = () => {
  const query = new URLSearchParams(window.location.search);
  const fallbackPath = query.get("redirect");
  if (fallbackPath?.startsWith("/")) {
    window.history.replaceState(null, "", fallbackPath);
    return fallbackPath.split("?")[0];
  }
  return window.location.pathname;
};

const LandingPage = () => (
  <iframe
    src="/landing.html"
    title="Escape the Bias landing page"
    style={{ display: "block", width: "100%", minHeight: "100vh", border: 0 }}
  />
);

function App() {
  return resolvePath() === "/game" ? <AethelonLevelFlow /> : <LandingPage />;
}

export default App;
